import React, { useMemo } from "react";
import moment from "moment-timezone";

import Header from "../components/third_screen/Header";
import Footer from "../components/third_screen/Footer";
import PrayerTimesPanel from "../components/third_screen/PrayerTimingsPanel";

import { getNextPrayerOrJummah } from "../utils/prayerUtils";

const ThirdScreen = ({ 
  colorSettings = {}, 
  prayerData, 
  timezone, 
  currentTime,
  moduleData, 
  announcements 
}) => {
  const {
    headerBackgroundColor = "#dee2ff",
    headerTextColor = "#000000",
    headerTimingColor = "#000000",

    bodyBackgroundColor = "#000000",
    bodyTextColor = "#ffffff",
    bodyTimingColor = "#15df57",

    highlightColor = "#CF10FF",

    footerBackgroundColor = "#dee2ff",
    footerTextColor = "#000000",
    footerTimingColor = "#7873b5",
  } = colorSettings;

  const nextEvent = useMemo(() => {
    if (!prayerData || !timezone || !currentTime) return null;
    return getNextPrayerOrJummah(currentTime, prayerData.iqamatimes, prayerData.jummahTimes, 0);
  }, [currentTime, prayerData, timezone]);

  const isJummahMode = useMemo(() => {
    if (!prayerData?.iqamatimes || !currentTime) return false;
    if (nextEvent?.type === 'jummah') return true;

    const isFriday = currentTime.day() === 5;
    if (isFriday) {
       const dateStr = currentTime.format("YYYY-MM-DD");
       const dhuhrStr = prayerData.iqamatimes.dhuhr || prayerData.iqamatimes.zuhr;
       const asrStr = prayerData.iqamatimes.asr;

       if (dhuhrStr && asrStr) {
          const dhuhrTime = moment.tz(`${dateStr} ${dhuhrStr}`, "YYYY-MM-DD h:mm A", timezone);
          const asrTime = moment.tz(`${dateStr} ${asrStr}`, "YYYY-MM-DD h:mm A", timezone);
          if (currentTime.isSameOrAfter(dhuhrTime) && currentTime.isBefore(asrTime)) return true;
       }
    }
    return false;
  }, [currentTime, prayerData, timezone, nextEvent]);

  if (!prayerData || !timezone || !currentTime) {
    return <div className="w-full h-screen bg-black text-white flex items-center justify-center">Loading...</div>;
  }

  return (
    <div className="bg-black text-white min-h-screen w-screen flex flex-col font-sans overflow-hidden p-[0.3svh]">
      
      {/* --- HEADER --- */}
      <div className="flex justify-between items-center shrink-0">
        <Header 
            backgroundColor={headerBackgroundColor}
            timingColor={headerTimingColor} 
            textColor={headerTextColor} 
            prayerData={prayerData}
            timezone={timezone}
            currentTime={currentTime}
        />
      </div>

      {/* --- BODY --- */}
      <div
        className="flex-1 overflow-y-auto px-0"
        style={{ 
            backgroundColor: bodyBackgroundColor, 
            color: bodyTextColor 
        }}
      >
        <PrayerTimesPanel
          highlightColor={highlightColor}
          labelTextColor={bodyTextColor}
          timingTextColor={bodyTimingColor}
          textColor={bodyTextColor}
          prayerData={prayerData}
          nextEvent={nextEvent}
          isJummahMode={isJummahMode}
          masjidTimeZone={timezone}
        />
      </div>

      {/* --- FOOTER --- */}
      {/* ✅ Removed 'justify-evenly', added 'w-full' to let Footer component handle spread */}
      <div className="flex w-full shrink-0">
        <Footer 
            backgroundColor={footerBackgroundColor}
            timingColor={footerTimingColor} 
            textColor={footerTextColor}
            highlightColor={highlightColor}
            nextEvent={nextEvent}
            prayerData={prayerData}
            announcements={announcements} 
        />
      </div>

    </div>
  );
};

export default ThirdScreen;